export const CHANGE_REQUEST_ACTION = {
    SUBMIT: 'submit',
    START_INTERNAL_REVIEW: 'start-internal-review',
    SEND_TO_CLIENT: 'send-to-client',
    APPROVE: 'approve',
    REQUEST_CHANGES: 'request-changes',
    REJECT: 'reject',
    SCHEDULE: 'schedule',
    COMPLETE: 'complete',
    CANCEL: 'cancel',
    REOPEN_DRAFT: 'reopen-draft',
    EDIT: 'edit',
    GENERATE_TASKS: 'generate-tasks',
};
//# sourceMappingURL=change-requests.js.map